export function resetSavedRouteSettings({commit}) {
    commit('setSavedRouteSettings', false)
    commit('setSavedRouteTime', false)
}

export function resetQueryRouteSettings({commit}) {
    commit('setQueryRouteSettings', false)
    commit('setQueryRouteSettingsChanges', [])
}

export function resetQueryPoiSettings({commit}) {
    commit('setQueryPoiSettings', false)
}